import { MenuItem } from 'common/models/page-config.models';
import SideNavModuleItem from './SideNavModuleItem';
import { KWELLO_ICON } from 'common/components/icon/KwelloSvgIcon';
import { useSelector } from 'react-redux';
import { selectUser } from 'common/store/slices/auth.slice';
import { useResize } from 'common/hooks/resize';
import { PROFILE_CAPTURE_ROUTES, USER_ROUTES } from 'routes/routes.const';
import { useCompareUrlWithProjectId } from 'common/hooks/route';
import { useParams } from 'react-router-dom';
import { PROJECT_ID_PLACEHOLDER } from 'common/constants';

interface SideNavUserMenuProps {
  isSidebarOpen: boolean;
  onClick: (item: MenuItem) => void;
  onChildClick: (item: MenuItem) => void;
  expanded: string;
}

export const signOutLink: MenuItem = {
  sortOrder: 4,
  id: 'sign_out',
  text: 'Sign Out',
  icon: 'LOG_OUT_ICON' as KWELLO_ICON,
};

export const supportLink: MenuItem = {
  sortOrder: 2,
  id: 'intercom_help_center',
  text: 'Support',
  icon: 'LIFE_BUOY' as KWELLO_ICON,
};

function SideNavUserMenu({
  isSidebarOpen,
  onClick,
  onChildClick,
  expanded,
}: Readonly<SideNavUserMenuProps>) {
  const user = useSelector(selectUser);
  const { isMobile } = useResize();
  const { compareUrl } = useCompareUrlWithProjectId();
  const { projectId } = useParams();
  const isProfileCapture = compareUrl(PROFILE_CAPTURE_ROUTES.root, { includes: true });

  const displayOnly = isProfileCapture;

  const baseMenuItem: MenuItem = {
    sortOrder: 1,
    id: 'user-menu',
    text: user?.externalName ?? 'User',
    customIcon: user?.picture,
  };

  const menuConfig: MenuItem = {
    ...baseMenuItem,
    route: USER_ROUTES.root,
    children: isMobile
      ? [signOutLink]
      : [
          {
            sortOrder: 1,
            id: 'settings',
            text: 'Settings',
            route: USER_ROUTES.settings,
            icon: 'SETTINGS_ICON' as KWELLO_ICON,
          },
          supportLink,
          {
            sortOrder: 3,
            id: 'files',
            text: 'Files',
            route: USER_ROUTES.files.replace(PROJECT_ID_PLACEHOLDER, projectId as string),
            icon: 'FOLDER_DOWNLOAD' as KWELLO_ICON,
          },
          signOutLink,
        ],
  };

  if (displayOnly) {
    return (
      <div>
        <SideNavModuleItem
          displayOnly={displayOnly}
          open={isSidebarOpen}
          {...baseMenuItem}
          onClick={() => {}}
          onChildClick={() => {}}
        />
      </div>
    );
  }

  return (
    <div>
      <SideNavModuleItem
        open={isSidebarOpen}
        {...menuConfig}
        onClick={onClick}
        onChildClick={onChildClick}
        expanded={expanded}
      />
    </div>
  );
}

export default SideNavUserMenu;
